<template>
    <div class="guest-layout">
		<div class="wrapper">
			<div class="logo"><img src="@/assets/img/upmood_logo.svg" alt="Upmood Workspace Logo"></div>
            <slot name="guest-body"/>

			<!-- <div class="language-container" @click="toggleLanguage = !toggleLanguage" v-on-clickaway="closeLanguage">
				<section class="label-container">
					<span class="language-label">
						{{ signUpText.language_label }}:
					</span>

					<span class="language-value">
						{{ selectedLanguage }}
					</span>
				</section>

				<ul class="dropdown-container" :class="{ 'active' : toggleLanguage}">
					<li class="dropdown-item" @click="setLanguage('japanese')">
						<img
							class="item-icon"
							src="http://developers.studenttriangle.com/flags/Japan.png"
							alt="Country Flag"
						>

						<span class="language-name">
							Japanese
						</span>
					</li>

					<li class="dropdown-item" @click="setLanguage('english')">
						<img
							class="item-icon"
							src="http://developers.studenttriangle.com/flags/United_States_of_America.png"
							alt="Country Flag"
						>

						<span class="language-name">
							English
						</span>
					</li>
				</ul>
			</div> -->
        </div>
	</div>
</template>

<script>
// import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			// toggleLanguage: false
		}
	},

	computed: {
		// ...mapGetters({
		// 	selectedLanguage: 'getLanguage',
		// 	signUpText: 'getSignUpTranslation'
		// })
	},

	methods: {
		// async setLanguage (language) {
		// 	await this.$store.dispatch('setLanguage', language)
		// 	await this.$store.dispatch('getBeforeAuthTranslation')
		// },

		// closeLanguage () {
		// 	this.toggleLanguage = false
		// }
	}
}
</script>

<style lang="scss" scoped>
.guest-layout {
	width: 100%;
	min-height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
    overflow: auto;
    padding: 50px 10px;
    background-color: #4CCBB6;
    background-image: linear-gradient(to bottom, #4CCBB6 , #41C2C5) !important;
    background-repeat: no-repeat;
    background-size: cover;

	.wrapper {
		width: 650px;
		background-color: #fff;
		box-shadow: 0 1px 10px #aaa;
		padding: 20px 0;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		justify-content: center;
        align-items: center;

		.logo {
			padding: 40px 0;

			img {
				width: 100px;
				height: auto;
				margin: 0 auto;
			}
		}

		.guest-body {
			flex: 1 1 auto;
			padding: 10px 0;
			width: 71%;
		}
    }

	&.box {
		.logo > img {
			width: 180px;
		}
	}

	.language-container {
		position: relative;
		padding: 15px 45px 15px 20px;
		opacity: 1;
		transition: opacity 0.3s ease 0.5s;
		cursor: pointer;
		// border: 1px solid #b8b7b7;
		align-self: center;
		border-radius: 3px;
		background: #fdfdfd;

		&::after {
			content: '';
			position: absolute;
			right: 20px;
			top: 20px;
			width: 7px;
			height: 7px;
			border-top: 2px solid #555;
			border-right: 2px solid #555;
			display: inline-block;
			transform: rotateZ(135deg);
			pointer-events: none;
		}

		.label-container {
			span {
				display: inline-block;
				color: #555;
			}

			.language-label {
				font-weight: 600;
				margin-right: 5px;
				font-size: 14px;
			}

			.language-value {
				font-size: 14px;
				text-transform: capitalize;
			}
		}

		.dropdown-container {
			top: -100px;
			width: 100%;
			list-style: none;
			right: 0px;
			position: absolute;
			transform: rotate(180deg);
			border-radius: 3px;
			overflow: hidden;
			opacity: 0;
			pointer-events: none;
			transition: 0.3s;
			border: 1px solid #b8b7b7;
			border-radius: 3px;
			background: #fdfdfd;

			&.active {
				opacity: 1;
				pointer-events: all;
			}

			.dropdown-item {
				display: flex;
				align-items: center;
				padding: 15px;
				transform: rotate(180deg);
				transition: 0.3s;

				&:hover {
					background: #e7e7e7;
				}

				.item-icon {
					width: 25px;
					height: 16px;
					margin-right: 8px;
					border: 1px solid #b8b7b7;
				}

				.language-name {
					color: #505050;
					display: inline-block;
				}
			}
		}
	}
}
</style>
